<template>
  <div class="tender-classification" v-if="classifications.length">
    <div class="title">
      {{ $t('tender-details.classifications-and-cat') }}
    </div>
    <div class="tender-classification__classification">
      <div v-if="showLessClassifications" class="tender-classification__value">
        <ul>
          <li v-for="(classification, idx) in firstClassifications" :key="idx">
            {{ classification.description }}<span v-if="classification.scheme">( {{ classification.scheme }} )</span>
          </li>
        </ul>
      </div>
      <div v-else class="tender-classification__value">
        <ul>
          <li v-for="(classification, idx) in classifications" :key="idx">
            {{ classification.description }}<span v-if="classification.scheme">( {{ classification.scheme }} )</span>
          </li>
        </ul>
      </div>
      <button
        v-if="hasMoreClassificationsToDisplay"
        @click="showLessClassifications = !showLessClassifications"
        class="tender-classification__show-more"
        data-test="seemore-button"
      >
        {{ showLessClassifications ? $t('tender-details.show-more') : $t('tender-details.show-less') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TenderClassification',
  props: {
    classifications: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showClassificationsLimitation: 5,
      showLessClassifications: true,
    };
  },
  computed: {
    hasClassifications() {
      return this.classifications.length > 0;
    },
    firstClassifications() {
      return this.classifications.slice(0, this.showClassificationsLimitation);
    },
    hasMoreClassificationsToDisplay() {
      return this.classifications.length > this.showClassificationsLimitation;
    },
  },
};
</script>

<style lang="scss">
.tender-classification {
  padding: 2rem;
  background: $color-white;
  margin-bottom: 1rem;
  border-radius: $border-radius-root;

  &__value {
    color: $color-normal-pale;
    font-size: $font-size-small;
    line-height: 1.43;
    list-style-type: none;
    word-break: break-word;

    &:first-child {
      padding-top: 1rem;
    }
  }

  li {
    color: $color-normal-pale;
    font-size: $font-size-small;
    line-height: 1.43;
    list-style-type: none;
    word-break: break-word;
  }

  &__show-more {
    color: $color-accent;
    font-size: $font-size-small;
    padding-top: 0.6rem;
    text-decoration: none;
  }
}
</style>
